import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        order: require('./modules/order').default,
        locale: require('./modules/locale').default,
    },
});
